var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"lg":_vm.cols_number,"md":_vm.cols_number,"xl":_vm.cols_number,"sm":"4"}},[_c('v-img',{attrs:{"src":require('@/assets/medallas/' + _vm.value.image),"height":"150","contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }